export default __webpack_public_path__ + "static/media/au-nsw.2beb11e2.svg";